import { render, staticRenderFns } from "./AccordionMenu.vue?vue&type=template&id=c473e760&"
import script from "./AccordionMenu.vue?vue&type=script&lang=js&"
export * from "./AccordionMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports